"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _dateLibWrapper = _interopRequireDefault(require("../helpers/date-lib-wrapper"));

var _time = require("../constants/time");

var _createFormatNumber = _interopRequireDefault(require("./create-format-number"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var I18N_NESTING_KEY_SEPARATOR = '$';

var getDateLocale = function getDateLocale(lng) {
  return _time.DATE_LOCALES[lng] || _time.DATE_LOCALES['en'];
};

var getDateFormat = function getDateFormat(lng) {
  return _time.DATE_FORMATS[lng] || _time.DATE_FORMATS['en'];
};

var getI18Config = function getI18Config() {
  return {
    keySeparator: I18N_NESTING_KEY_SEPARATOR,
    interpolation: {
      escapeValue: false,
      format: function format(value, _format, lng) {
        if (lng === void 0) {
          lng = 'en';
        }

        switch (_format) {
          case 'uppercase':
            return value.toUpperCase();

          case 'number':
            return (0, _createFormatNumber["default"])(lng)(value);

          case 'timeRelative':
            return (0, _dateLibWrapper["default"])(value).locale(getDateLocale(lng)).fromNow();

          case 'date':
            return (0, _dateLibWrapper["default"])(value).locale(getDateLocale(lng)).format(getDateFormat(lng));

          case 'fullDate':
            return (0, _dateLibWrapper["default"])(value).locale(getDateLocale(lng)).format('ll');

          case 'hoursAndMinutes':
            return (0, _dateLibWrapper["default"])(value).locale(getDateLocale(lng)).format('LT');

          case 'monthAndYear':
            return (0, _dateLibWrapper["default"])(value).locale(getDateLocale(lng)).format('MMMM YYYY');

          case 'monthAndYearUtc':
            return (0, _dateLibWrapper["default"])(value).utc().locale(getDateLocale(lng)).format('MMMM YYYY');

          default:
            return value;
        }
      }
    }
  };
};

var _default = getI18Config;
exports["default"] = _default;